// extracted by mini-css-extract-plugin
module.exports = {"header":"_8d3a406","menu":"_48f17e6","brandIcon":"_446ddd7","sideMenu":"_871dd10"};